export const SET_MEDIA_DEVICES_ENABLED = '@application/SET_MEDIA_DEVICES_ENABLED';
export const SET_MODAL_OPENING_COUNT = '@application/SET_MODAL_OPENING_COUNT';
export const SET_REQUIRES_PERMISSION_REQUEST = '@application/SET_REQUIRES_PERMISSION_REQUEST';
export const SET_LANGUAGE = '@application/SET_LANGUAGE';
export const SET_LIGHT_REGISTRATION = '@application/SET_LIGHT_REGISTRATION';
export const SET_RETURN_TO = '@application/SET_RETURN_TO';
